import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-detail-program-desc-grafica',
  templateUrl: './detail-program-desc-grafica.component.html'
})
export class DetailProgramDescGraficaComponent implements OnInit {
  @Input() identifier
  @Input() data
  active = 0

  constructor() {
  }

  ngOnInit() {}
}
